export const NOT_ATTENDED_STATUS_LABEL = 'NA';

export const STAFF_TRAINING_STATUSES = {
    BEHIND: 'behind',
    ON_TRACK: 'onTrack',
    AHEAD: 'ahead',
} as const;

export type StaffTrainingStatus = (typeof STAFF_TRAINING_STATUSES)[keyof typeof STAFF_TRAINING_STATUSES];

/**
 * PostHog flag gating TRAINING custom fields (CUR-1063). Off by default in every
 * environment. Lives in this alias-free module so the route-registry generator
 * (which runs under tsx without path aliases) can import it.
 */
export const TRAINING_CUSTOM_FIELDS_FLAG_KEY = 'enable-training-custom-fields';
